import {
  FlexRow,
  type FlexRowProps,
} from '@framework/ui/components/row/FlexRow.tsx';
import { Space, Typography } from 'antd';
import clx from 'classnames';
import type React from 'react';
import { down } from 'styled-breakpoints';
import { useBreakpoint } from 'styled-breakpoints/react-styled';
import styled, { useTheme } from 'styled-components';
import { FrontPageActionsContainer, FrontPageTitleContainer } from '#theme';

const { Text, Title } = Typography;

const TitleMobileSpaceWrapper = styled(Space)`
  width: 100%;
`;

const TitleSubmissionRowWrapper = styled.div`
  padding: 16px 0;
  // fix del titolo quahdo la card contiene tabs
  .ant-card-contain-tabs & {
    padding: 0;
  }
  &.no-padding {
    padding: 0;
  }
  &.has-extra-right-element {
    // per mostrare completamente il focus di accesibilità del pulsante
    padding-right: 5px;
  }
`;

const StyledTitle = styled(Title)`
  &&& {
    &.ant-typography {
      margin-bottom: 0;
      overflow: unset;
      white-space: wrap;
      text-overflow: unset;
    }
  }
`;

export interface TitleSubmissionRowProps extends FlexRowProps {
  noPadding?: boolean;
  stateTag?: React.ReactNode;
  /** Riga dopo il titolo @deprecated potrebbe creare problemi di visualizzazione */
  afterTitle?: React.ReactNode;
  /** Per spostare il focus sul titolo se necessario - accessibilità */
  id?: string;
}

/**
 * Titolo della richiesta
 */
export function TitleSubmissionRow(props: TitleSubmissionRowProps) {
  const { children, noPadding, stateTag, afterTitle, id, ...rest } = props;
  const isMobile = useBreakpoint(down('md'));
  const theme = useTheme();

  const after = theme.submissionStateTagPositionAfter ? stateTag : null;
  const before = theme.submissionStateTagPositionAfter ? null : stateTag;

  const pageTitle = (
    <FrontPageTitleContainer>
      {before}
      <StyledTitle
        level={1}
        id={id ?? undefined}
        tabIndex={id ? -1 : undefined}
      >
        {children}
      </StyledTitle>
      {after}
    </FrontPageTitleContainer>
  );

  const pageActions = (
    <FrontPageActionsContainer>{rest.right}</FrontPageActionsContainer>
  );

  return (
    <TitleSubmissionRowWrapper
      className={clx({
        'no-padding': noPadding,
        'has-extra-right-element': !!props.right,
      })}
    >
      {isMobile ? (
        <TitleMobileSpaceWrapper direction="vertical">
          {rest.left}
          <FlexRow {...rest} left={undefined} right={undefined}>
            {pageTitle}
          </FlexRow>
          {pageActions}
        </TitleMobileSpaceWrapper>
      ) : (
        <FlexRow {...rest} right={pageActions}>
          {pageTitle}
        </FlexRow>
      )}
      {afterTitle}
    </TitleSubmissionRowWrapper>
  );
}
